export default "__VITE_ASSET__ClDiCOM9__"